<template>
<div id="app">
  <div class="nav">
    <button v-on:click="page = 'home'">Home</button>
    <button v-on:click="page = 'projects'">Projects</button>
    <button v-on:click="page = 'about'">About</button>
  </div>
  <transition name="fade">
    <home v-if="page == 'home'"/>
    <projects v-if="page == 'projects'"/>
    <about v-if="page == 'about'"/>
  </transition>
</div>
</template>

<script>
import home from './components/home'
import projects from './components/projects'
import about from './components/about'

export default {
  name: 'App',
  components: {
    home,
    projects,
    about
  },
  data () {
    return {
      page: 'home'
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
color: #2c3e50;
       margin-top: 60px;
}
.text {
  font-size: 14px;
  font-family: monospace;
  text-align: justify;
  text-align-last: center;
  position: relative;
  display: block;
  width: 40%;
  margin: auto;
  padding: 0.5%;
}

h1,h2 {
  font-family: Arial, Helvetica, sans-serif;
}

li {
  text-align-last: left;
}

.fade-enter-active, .fade-leave-active {
  transition: all .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateX(50%);
  display: inline;
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/App.vue